// extracted by mini-css-extract-plugin
export default {"formGroup":"FormGroup_formGroup__gMm6L","label":"FormGroup_label__HiwYj","icon":"FormGroup_icon__yQulh","required":"FormGroup_required__jsBJP"};